<template>
  <paper>
    <div class="comprehensive-grade">
      <div class="grade-head">
        <div class="head-left">
          <h4 class="head-left-title">{{bidData.bidName}}</h4>
          <div class="head-left-bottom">
            <div class="text">
              <span class="text-left">招标编码</span>
              <span class="text-right">{{bidData.bidNo}}</span>
            </div>
          </div>
        </div>
        <div class="head-right">
       <el-button type="primary" @click="saveBtn" :loading="loadSave" :disabled="submit?false:true">保存</el-button>
       <el-button type="primary" @click="pullBtn" :loading="loadPull" :disabled="submit?false:true">提交</el-button>
        </div>
      </div>
      <div class="grade-table">
        <h4 class="table-title">综合评分项</h4>
        <el-table
          :data="tableData"
          style="width: 100%;"
          row-key="id"
          border
          default-expand-all
          :tree-props="{children: 'childList', hasChildren: 'hasChildren'}"
        >
          <el-table-column prop="scoreAttributeText" label="评分属性" align="center"></el-table-column>
          <el-table-column prop="scoreItem" label="评分项" align="center"></el-table-column>
          <el-table-column
            prop="scoreStandard"
            label="评分标准"
            align="center"
            width="350"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="scoreScale" label="权重(%)" align="center" width="70"></el-table-column>
          <template v-for="item in columns">
            <el-table-column :key="item.prop" :prop="item.prop" :label="item.label" align="center">
              <template slot-scope="scope">
                <div class="input-box" v-if="scope.row.scoreId">
                  <el-input-number
                    v-model="scope.row[item.prop]"
                    ref="input"
                    @blur="changeScore(scope.row[item.prop],scope.row.scoreScale,$event)"
                    :precision="2"
                    controls-position="right"
                    :step="1"
                    :min="0"
                    :max="100"
                    :controls="false"
                  ></el-input-number>
                </div>
                <span v-else>{{scope.row[item.prop]}}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
    </div>
  </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import {
    scoreHead,
    parentList,
    saveList,
    pullList
} from '../../../../lsrm/api/compScore.js';
import { tenderEnquiry } from '../../../api/tenderEnquiry.js';
import { dictWithUrl } from '@/components/lots/api';
export default {
    components: { paper },
    data() {
        return {
            loadSave: false,
            loadPull: false,
            bidData: {},
            submit: '',
            columns: [],
            tableData: [],
            saveList: [],
            pullList: [],
            iflowId: this.$route.query.mbpmFlowId,
            dictData: {} // 数字字典
        };
    },
    mounted() {
    // 数字字典转换
        dictWithUrl('BID_SCORING_ATTRIBUTE').then(res => {
            this.dictData = res.data;
            this.init();
        });
    },
    methods: {
    // 保存
        async saveBtn() {
            const list = [];
            this.tableData.forEach(item => {
                list.push(...item.childList);
            });
            this.columns.forEach(item => {
                list.forEach(item2 => {
                    for (const key in item2) {
                        if (key === item.prop) {
                            const obj = {
                                bidNo: this.$route.query.bidNo,
                                id: item2.id,
                                supplierCode: key,
                                score: item2[key],
                                raterCode: item2.raterCode,
                                scoreScale: item2.scoreScale,
                                scoreAttribute: item2.scoreAttribute,
                                scoreId: item2.scoreId
                            };
                            this.saveList.push(obj);
                        }
                    }
                });
            });
            for (let i = 0; i < this.saveList.length; i++) {
                if (this.saveList[i].score === null) {
                    this.$refs.input[i].$el.firstElementChild.style.borderColor = 'red';
                }
            }
            for (let i = 0; i < this.$refs.input.length; i++) {
                if (this.$refs.input[i].$el.firstElementChild.style.borderColor === 'red') {
                    this.$message({
                        showClose: true,
                        message: '保存失败,输入不符合规则',
                        type: 'error'
                    });
                    this.saveList = [];
                    return false;
                }
            }
            this.loadSave = true;
            const res = await saveList(this.saveList);
            this.loadSave = false;
            if (res && res.code === '0') {
                this.init();
                this.$message({
                    showClose: true,
                    message: '保存成功',
                    type: 'success'
                });
            }
            this.saveList = [];
        },
        totalFn(sum, i, k) {
            for (let j = 0; j < this.tableData[i].childList.length; j++) {
                for (const key in this.tableData[i].childList[j]) {
                    if (key === this.columns[k].prop) {
                        sum += this.tableData[i].childList[j][key];
                    }
                }
            }
            return sum;
        },
        // 提交
        async pullBtn() {
            const list = [];
            this.tableData.forEach(item => {
                list.push(...item.childList);
            });
            this.columns.forEach(item => {
                list.forEach(item2 => {
                    for (const key in item2) {
                        if (key === item.prop) {
                            const obj = {
                                bidNo: this.$route.query.bidNo,
                                id: item2.id,
                                supplierCode: key,
                                score: item2[key],
                                raterCode: item2.raterCode,
                                scoreScale: item2.scoreScale,
                                scoreAttribute: item2.scoreAttribute,
                                scoreId: item2.scoreId
                            };
                            this.pullList.push(obj);
                        }
                    }
                });
            });
            for (let i = 0; i < this.pullList.length; i++) {
                if (this.pullList[i].score === null) {
                    this.$refs.input[i].$el.firstElementChild.style.borderColor = 'red';
                }
            }
            for (let i = 0; i < this.$refs.input.length; i++) {
                if (this.$refs.input[i].$el.firstElementChild.style.borderColor === 'red') {
                    this.$message({
                        showClose: true,
                        message: '提交失败,评分不能大于权重，总分不能大于100',
                        type: 'error'
                    });
                    this.pullList = [];
                    return false;
                }
            }
            // 遍历算出技术分和商务分总和，只要有超过100的就提示
            for (let i = 0; i < this.tableData.length; i++) {
                for (let k = 0; k < this.columns.length; k++) {
                    let sum = 0;
                    sum = this.totalFn(sum, i, k);
                    if (sum > 100) {
                        this.$message({
                            showClose: true,
                            message: `${this.columns[k].label}${this.tableData[i].attributeName}权重总和超过100`,
                            type: 'error'
                        });
                        return false;
                    }
                }
            }
            this.loadPull = true;
            const res = await pullList(this.pullList);
            this.loadPull = false;
            if (res && res.code === '0') {
                this.init();
                this.$message({
                    showClose: true,
                    message: '提交成功',
                    type: 'success'
                });
            }
            this.pullList = [];
        },
        conversionData(list) {
            list.forEach(item => {
                item.scoreAttributeText = this.dictData.BID_SCORING_ATTRIBUTE[item.scoreAttribute];
                if (item.childList) {
                    item.childList.forEach(el => {
                        el.scoreAttributeText = this.dictData.BID_SCORING_ATTRIBUTE[el.scoreAttribute];
                    });
                }
            });
        },
        async init() {
            const bidRes = await tenderEnquiry({ bidNo: this.$route.query.bidNo, iflowId: this.iflowId });
            this.bidData = bidRes.data.list[0];
            // 截取url上的参数
            const res = await scoreHead({ bidNo: this.$route.query.bidNo });
            if (res && res.code === '0') {
                this.columns = res.data; // 获取供应商表头
                const parentRes = await parentList({ bidNo: this.$route.query.bidNo });
                if (parentRes && parentRes.code === '0') {
                    this.tableData = parentRes.data; // 获取数据
                    this.conversionData(this.tableData);
                }
            }
            // 判断是否提交
            if (this.tableData[0]) {
                if (this.tableData[0].childList[0].scoreStatus === '1') {
                    this.submit = true;
                } else {
                    this.submit = false;
                }
            }
        },
        changeScore(val, scoreScale, event) {
            if (val * 1 < 0 || val * 1 > scoreScale * 1 || window.isNaN(val * 1)) {
                event.target.style.borderColor = 'red';
            } else {
                event.target.style.borderColor = '#CECECE';
            }
        }
    }
};
</script>
<style lang="less">
.comprehensive-grade {
  min-height: 800px;
  .grade-head {
    padding: 0 17px;
    display: flex;
    background-color: #f6f6f7;
    justify-content: space-between;
    .head-left-title {
      margin: 0;
      margin-top: 20px;
      font-size: 16px;
    }
    .head-left-bottom {
      margin-top: 10px;
      margin-bottom: 20px;
      display: flex;
    }
    .text {
      display: flex;
      align-items: center;
    }
    .text-left {
      margin-right: 5px;
      font-size: 12px;
      color: #888888;
      line-height: 12px;
    }
    .text-right {
      margin-top: 0;
      margin-right: 15px;
      font-size: 12px;
      color: #333333;
      line-height: 12px;
    }
  }
  .head-right {
    display: flex;
    align-items: center;
  }
  .grade-table {
    margin-top: 20px;
    .table-title {
      margin: 0;
      margin-bottom: 10px;
    }
    .cell {
      display: flex;
      align-items: center;
    }
  }
}
</style>
